export default __webpack_public_path__ + "static/media/img-intro-overview-ko@2x.b649ef60.png";